import Constants from '../../../utils/Constants';
import buildImg from '../../../assets/imgs/advantage/build.webp';
import garageImg from '../../../assets/imgs/advantage/garage.webp';
import interiorImg from '../../../assets/imgs/advantage/interior.webp';

const Advantage = () => {
  return (
    <div id={Constants.ADVANTAGE} className='advantage'>
      <div className='advantage_container container'>
        <h2 data-aos='fade-up' className='text_center'>
          PREDNOSTI
        </h2>
        <div className='advantage_container_section'>
          <div
            data-aos='fade-left'
            data-aos-delay='50'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={buildImg} alt='podzemni parking' />
            </div>
            <h3>VRHUNSKA GRADNJA</h3>
            <p>
              Osnovna konstrukcija objekata će biti armirano-betonska, s
              toplinski i zvučno izoliranom ETICS fasadom (10 cm kamene vune),
              dok će krovna fasada biti zaštićena kvalitetnom hidro-izolacijskom
              membranom.
            </p>
          </div>
          <div
            data-aos='fade-left'
            data-aos-delay='150'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={interiorImg} alt='kvalitetna gradnja' />
            </div>
            <h3>VRHUNSKI INTERIJER</h3>
            <p>
              Stanovi će biti opremljeni s vrhunskim parketom, sanitarijama i
              pločicama, protupožarnim vratima, modernim sobnim vratima i PVC
              zatvorima. U svaki stan će biti ugrađeni klima uređaj i video
              parlafon u boji.
            </p>
          </div>
          <div
            data-aos='fade-left'
            data-aos-delay='250'
            className='advantage_container_section_card'
          >
            <div className='advantage_container_section_card_img'>
              <img src={garageImg} alt='uređeni okoliš' />
            </div>
            <h3>PODZEMNI PARKING</h3>
            <p>
              Obe zgrade će imati podzemni parking na dvije etaže sa 151
              garažnim mjestom. Garažni boxevi s rolo vratima će imati svoj
              daljinski upravljač. Garaža će biti povezana sa stambenim dijelom
              preko dizala.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Advantage;
